module.exports = __webpack_public_path__ + "static/media/Fred Speers.31a186cf.png";